export const WEEKDAYS = {
    0: {
        id: 0,
        title: 'Monday',
        short: 'M'
    },
    1: {
        id: 1,
        title: 'Tuesday',
        short: 'Tu'
    },
    2: {
        id: 2,
        title: 'Wednesday',
        short: 'W'
    },
    3: {
        id: 3,
        title: 'Thursday',
        short: 'Th'
    },
    4: {
        id: 4,
        title: 'Friday',
        short: 'F'
    },
    5: {
        id: 5,
        title: 'Saturday',
        short: 'Sa'
    },
    6: {
        id: 6,
        title: 'Sunday',
        short: 'Su'
    }
};
//# sourceMappingURL=weekday.js.map